import App from 'app/app.js';

function LtOnInputPauseDirective() {
  return {
    restrict: 'A',
    scope: {
      ltOnInputPause: '&'
    },
    link: function linkFn(scope, element, attrs) {
      var trigger = function () {
        scope.ltOnInputPause();
      };

      var timeout;
      element.on('input', function () {
        var value = element.val();
        if (!!value) {
          clearTimeout(timeout);
          timeout = setTimeout(trigger, 500);
        } else {
          clearTimeout(timeout);
        }
      });
    }
  };
}

App.directive('ltOnInputPause', [LtOnInputPauseDirective]);
